/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hof_Meta_DescriptionInputs */

const en_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore five decades of moments with champions, students, and the game. Mark Egly's Hall of Fame corner.`)
};

const es_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora cinco décadas de momentos con campeones, alumnos y el juego. El rincón del Salón de la fama de Mark Egly.`)
};

const de_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entdecken Sie fünf Jahrzehnte voller Momente mit Champions, Studenten und dem Spiel. Mark Eglys Hall of Fame-Ecke.`)
};

const zh_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索与冠军、学生和比赛一起度过的五个十年的时刻。Mark Egly 的名人堂一角。`)
};

const ar_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استكشف خمسة عقود من اللحظات مع الأبطال والطلاب واللعبة. ركن قاعة المشاهير لدى Mark Egly.`)
};

const fr_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorez cinq décennies de moments avec les champions, les étudiants et le jeu. Le coin du Temple de la renommée de Mark Egly.`)
};

const vi_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khám phá năm thập kỷ khoảnh khắc với các nhà vô địch, học viên và môn thể thao. Góc Đại sảnh danh vọng của Mark Egly.`)
};

const sw_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gundua miongo mitano ya matukio na mabingwa, wanafunzi na mchezo. Mark Egly's Hall of Fame kona.`)
};

const th_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สำรวจช่วงเวลาห้าทศวรรษกับแชมป์เปี้ยน นักเรียน และเกม มุมหอเกียรติยศของ Mark Egly`)
};

const bs_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istražite pet decenija trenutaka sa šampionima, učenicima i igrom. Ugao Kuće slavnih Marka Eglyja.`)
};

const ja_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`王者たち、教え子たち、そしてゴルフと歩んだ50年の瞬間をご覧ください。Mark Eglyの殿堂コーナー。`)
};

const ko_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`챔피언, 제자들, 그리고 골프와 함께한 50년의 순간을 둘러보세요. Mark Egly의 명예의 전당 코너.`)
};

const pt_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore cinco décadas de momentos com campeões, estudantes e o jogo. Canto do Hall da Fama do Mark Egly.`)
};

const it_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esplora cinque decenni di momenti con campioni, studenti e il gioco. La Hall of Fame di Mark Egly.`)
};

const sv_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utforska fem decennier av ögonblick med mästare, elever och spelet. Mark Eglys Hall of Fame-hörna.`)
};

const nl_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontdek vijf decennia aan momenten met kampioenen, leerlingen en het spel. Mark Eglys Hall of Fame-hoek.`)
};

const da_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udforsk fem årtiers øjeblikke med mestre, studerende og spillet. Mark Egly 's Hall of Fame hjørne.`)
};

const nb_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utforsk fem tiår dreper med mestere, studenter og spillet. Mark Egly dreper hjørnet.`)
};

const fi_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutustu viiden vuosikymmenen hetkiin mestareiden, oppilaiden ja golfin parissa. Mark Eglyn Hall of Fame -kulma.`)
};

const pl_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poznaj pięć dekad chwil z mistrzami, uczniami i samą grą. Galeria sław Marka Egly’ego.`)
};

const ru_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пять десятилетий памятных моментов с чемпионами, учениками и самой игрой. Зал славы тренера Mark Egly.`)
};

const tr_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şampiyonlar, öğrenciler ve oyunla dolu elli yıllık anları keşfedin. Mark Egly'nin Şöhretler Müzesi köşesi.`)
};

const hi_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चैंपियनों, छात्रों और खेल के साथ पाँच दशकों के यादगार पलों को देखें। Mark Egly का हॉल ऑफ फेम कोना।`)
};

const id_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelajahi lima dekade momen bersama para juara, murid, dan permainan golf. Sudut Balai Kehormatan Mark Egly.`)
};

const ms_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terokai lima dekad detik bersama para juara, pelajar dan permainan golf. Sudut Dewan Kemasyhuran Mark Egly.`)
};

const cs_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prozkoumejte pět desetiletí momentů s šampiony, studenty a hru. Mark Egly je síň slávy.`)
};

const el_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εξερευνήστε πέντε δεκαετίες στιγμών με πρωταθλητές, μαθητές και το παιχνίδι. Η γωνιά του Πανθέου Διασήμων του Mark Egly.`)
};

const he_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 עשורים של רגעים עם אלופים, סטודנטים, ואת המשחק. Mark Egly's Hall of Fame`)
};

const af_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verken vyf dekades se oomblikke met kampioene, studente en die spel. Mark Egly se Eregalery-hoek.`)
};

const hu_hof_meta_description = /** @type {(inputs: Hof_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fedezd fel öt évtized pillanatait bajnokokkal, tanítványokkal és a játékkal. Mark Egly Hírességek csarnoka sarka.`)
};

/**
* | output |
* | --- |
* | "Explore five decades of moments with champions, students, and the game. Mark Egly's Hall of Fame corner." |
*
* @param {Hof_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const hof_meta_description = /** @type {((inputs?: Hof_Meta_DescriptionInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_Meta_DescriptionInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_hof_meta_description(inputs)
	if (locale === "de") return de_hof_meta_description(inputs)
	if (locale === "zh") return zh_hof_meta_description(inputs)
	if (locale === "ar") return ar_hof_meta_description(inputs)
	if (locale === "fr") return fr_hof_meta_description(inputs)
	if (locale === "vi") return vi_hof_meta_description(inputs)
	if (locale === "sw") return sw_hof_meta_description(inputs)
	if (locale === "th") return th_hof_meta_description(inputs)
	if (locale === "bs") return bs_hof_meta_description(inputs)
	if (locale === "ja") return ja_hof_meta_description(inputs)
	if (locale === "ko") return ko_hof_meta_description(inputs)
	if (locale === "pt") return pt_hof_meta_description(inputs)
	if (locale === "it") return it_hof_meta_description(inputs)
	if (locale === "sv") return sv_hof_meta_description(inputs)
	if (locale === "nl") return nl_hof_meta_description(inputs)
	if (locale === "da") return da_hof_meta_description(inputs)
	if (locale === "nb") return nb_hof_meta_description(inputs)
	if (locale === "fi") return fi_hof_meta_description(inputs)
	if (locale === "pl") return pl_hof_meta_description(inputs)
	if (locale === "ru") return ru_hof_meta_description(inputs)
	if (locale === "tr") return tr_hof_meta_description(inputs)
	if (locale === "hi") return hi_hof_meta_description(inputs)
	if (locale === "id") return id_hof_meta_description(inputs)
	if (locale === "ms") return ms_hof_meta_description(inputs)
	if (locale === "cs") return cs_hof_meta_description(inputs)
	if (locale === "el") return el_hof_meta_description(inputs)
	if (locale === "he") return he_hof_meta_description(inputs)
	if (locale === "af") return af_hof_meta_description(inputs)
	if (locale === "hu") return hu_hof_meta_description(inputs)
	return en_hof_meta_description(inputs)
});